// MetaTagsWrapper.tsx
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

interface MetaTagsProps {
  pageCode: string;
}

const MetaTagsWrapper: React.FC<MetaTagsProps> = ({ pageCode }) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;

  const [metaTags, setMetaTags] = useState({
    title: 'Default Title',
    description: 'Default Description',
    keywords: 'Default Keywords',
  });

  const fetchSeoMetaDetails = async () => {
    try {
      const response = await fetch(`${backendUrl}${version}seo-meta-details/${pageCode}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"       
        }
      );
      if (!response.ok) throw new Error('Failed to fetch SEO meta details');
      const data = await response.json();
      setMetaTags({
        title: data.result.page_title || 'Default Title',
        description: data.result.meta_description || 'Default Description',
        keywords: data.result.meta_tag || 'Default Keywords',
      });
    } catch (error) {
      //console.error('Error fetching SEO meta details:', error);
    }
  };

  useEffect(() => {
    fetchSeoMetaDetails();
  }, [pageCode]);

  return (
    <Helmet>
      <title>{metaTags.title}</title>
      <meta name="description" content={metaTags.description} />
      <meta name="keywords" content={metaTags.keywords} />
    </Helmet>
  );
};

export default MetaTagsWrapper;
